import { Box } from "@chakra-ui/react";
import { useFormikContext } from "formik";

import { CallsAlertsSearchBarValues, CallTypes, EventType } from "../../types";
import MultiSelectField from "../MultiSelectInputs";

function CallTypeSelect() {
  const { values } = useFormikContext<CallsAlertsSearchBarValues>();

  const isTypeAlert = values.eventType === EventType.Alert;
  return (
    <Box data-testid={`call-type-select${isTypeAlert ? "-disabled" : ""}`}>
      <MultiSelectField
        collapseInput
        label="Call Type"
        name="callType"
        options={CallTypes}
        isDisabled={isTypeAlert}
        testId="call-type"
      />
    </Box>
  );
}

export default CallTypeSelect;
